import { Component, OnInit } from '@angular/core';
import {NodeBuilder} from "../../../../../../../shared/models";
import { UntypedFormGroup, ReactiveFormsModule } from "@angular/forms";
import {EndFlowNode} from "./end-flow";
import { ClickatellExpansionPanelComponent } from '../../../../../../../shared/components/clickatell-expansion-panel/clickatell-expansion-panel.component';
import { MatExpansionPanelTitle } from '@angular/material/expansion';
import { NgTemplateOutlet, KeyValuePipe } from '@angular/common';
import { ActiveFormDirective } from '../../../../../../../shared/directives/active-form/active-form.directive';

const NODE_TYPE = 'endNode';

@Component({
    selector: 'end-flow',
    templateUrl: './end-flow.component.html',
    styleUrls: ['./end-flow.component.scss'],
    imports: [ClickatellExpansionPanelComponent, MatExpansionPanelTitle, ReactiveFormsModule, NgTemplateOutlet, ActiveFormDirective, KeyValuePipe]
})
export class EndFlowComponent extends NodeBuilder implements OnInit{

  endNodeForm: UntypedFormGroup = undefined;

  constructor() {
    super(NODE_TYPE);
  }

  ngOnInit(): void {
  }

  set buildForm(stepData: any) {
    this.endNodeForm = EndFlowNode.toForm(stepData, this.canEdit);
  }

  get getStepData(): {} {
    return new EndFlowNode(this.endNodeForm.getRawValue()).getStepData;
  }

  get isNodeValid(): boolean {
    return this.endNodeForm.valid;
  }

}
